import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-field p-col-2" }
const _hoisted_2 = { for: "name" }
const _hoisted_3 = { class: "p-field p-col-3" }
const _hoisted_4 = { for: "description" }
const _hoisted_5 = {
  key: 0,
  class: "p-error"
}
const _hoisted_6 = { class: "p-field p-col-3" }
const _hoisted_7 = { for: "color" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "p-field p-col-3" }
const _hoisted_10 = { for: "icon" }
const _hoisted_11 = {
  key: 0,
  class: "p-error"
}
const _hoisted_12 = {
  key: 1,
  class: "p-error"
}
const _hoisted_13 = { class: "p-field p-col-1 p-d-flex p-ai-start p-mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputGroupAddon = _resolveComponent("InputGroupAddon")!
  const _component_InputGroup = _resolveComponent("InputGroup")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_Button = _resolveComponent("Button")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t('Squeeze.System.ButtonName')) + " *", 1),
      _createVNode(_component_InputText, {
        id: "name",
        modelValue: _ctx.value.buttonName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value.buttonName) = $event)),
        disabled: ""
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('Squeeze.System.Description')), 1),
      _createVNode(_component_InputText, {
        id: "description",
        modelValue: _ctx.value.description,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value.description) = $event)),
        class: _normalizeClass({'p-invalid':_ctx.v$.description.maxLengthOfFifteenValidation.$invalid && _ctx.showErrorMessage})
      }, null, 8, ["modelValue", "class"]),
      (_ctx.v$.description.maxLengthOfFifteenValidation.$invalid && _ctx.showErrorMessage)
        ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(_ctx.$t('Forms.Val.ButtonDescription')), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('Squeeze.System.Color')), 1),
      _createVNode(_component_InputGroup, null, {
        default: _withCtx(() => [
          _createVNode(_component_InputGroupAddon, { class: "p-p-0" }, {
            default: _withCtx(() => [
              _createElementVNode("input", {
                ref: "colorInput",
                type: "color",
                value: _ctx.value.color,
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onChangeColor($event.target.value))),
                class: "input-color"
              }, null, 40, _hoisted_8)
            ]),
            _: 1
          }),
          _createVNode(_component_InputText, {
            id: "color",
            modelValue: _ctx.value.color,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.value.color) = $event)),
            onClick: _cache[4] || (_cache[4] = ($event: any) => {this.$refs.colorInput.click();}),
            readonly: ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('Squeeze.System.Icon')), 1),
        _withDirectives(_createVNode(_component_Badge, {
          class: "mdi mdi-comment-question-outline",
          onClick: _ctx.goToMaterialDesignIcons
        }, null, 8, ["onClick"]), [
          [
            _directive_tooltip,
            _ctx.$t('Squeeze.System.GoToMaterialDesignIcons'),
            void 0,
            { right: true }
          ]
        ])
      ]),
      _createVNode(_component_InputText, {
        id: "icon",
        modelValue: _ctx.value.icon,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.value.icon) = $event)),
        class: _normalizeClass({'p-invalid':(_ctx.v$.icon.isIconFormatCorrect.$invalid || _ctx.v$.icon.whitespaceValidation.$invalid) && _ctx.showErrorMessage})
      }, null, 8, ["modelValue", "class"]),
      (_ctx.v$.icon.isIconFormatCorrect.$invalid && _ctx.showErrorMessage)
        ? (_openBlock(), _createElementBlock("small", _hoisted_11, _toDisplayString(_ctx.$t('Forms.Val.ButtonIcon')), 1))
        : _createCommentVNode("", true),
      (_ctx.v$.icon.whitespaceValidation.$invalid && _ctx.showErrorMessage)
        ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(_ctx.$t('Forms.Val.NoWhitespace')), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _withDirectives(_createVNode(_component_Button, {
        type: "button",
        icon: "mdi mdi-content-save-outline",
        class: "p-button p-mr-1",
        onClick: _ctx.saveValidationButtonSettings
      }, null, 8, ["onClick"]), [
        [
          _directive_tooltip,
          _ctx.$t('Squeeze.General.Save'),
          void 0,
          { top: true }
        ]
      ]),
      _withDirectives(_createVNode(_component_Button, {
        type: "button",
        icon: "mdi mdi-delete-outline",
        class: "p-button p-button-danger",
        onClick: _ctx.resetValidationButtonSettings
      }, null, 8, ["onClick"]), [
        [
          _directive_tooltip,
          _ctx.$t('Squeeze.System.ResetValidationButtonSettings'),
          void 0,
          { top: true }
        ]
      ])
    ])
  ], 64))
}